var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterquality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5433)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 13,
    rx: 18,
    ry: 6,
    fill: "url(#paint0_linear_1_5433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13H41V46C41 48.7614 38.7614 51 36 51H10C7.23858 51 5 48.7614 5 46V13Z",
    fill: "url(#paint1_linear_1_5433)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_5433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5064 19.9555C22.5879 19.3846 23.4121 19.3847 23.4936 19.9555C23.4979 19.9851 23.5048 20.0143 23.5142 20.0427L24.0595 21.678C24.3529 22.5583 24.7085 23.4165 25.1234 24.2464L26.5001 26.9999L27.7931 29.9775C28.086 30.652 28.2371 31.3794 28.2371 32.1147L28.2371 32.7485C28.2371 33.9132 27.728 35.0197 26.8435 35.7774C26.2917 36.2502 25.6211 36.5632 24.9044 36.6827L24.0731 36.8212C23.3626 36.9396 22.6374 36.9396 21.9269 36.8212L21.1363 36.6894C20.395 36.5659 19.7061 36.228 19.1546 35.7176C18.3241 34.9489 17.8739 33.8536 17.9239 32.723L17.9563 31.9897C17.9852 31.3353 18.1322 30.6915 18.3903 30.0895L19.5001 27.4999L21.5002 23L22.4858 20.0427C22.4952 20.0143 22.5021 19.9851 22.5064 19.9555Z",
    fill: "#49A0FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5433",
    x: 0.1,
    y: 0.1,
    width: 53.8,
    height: 61.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_5433",
    x: 11.6199,
    y: 14.2274,
    width: 28.9174,
    height: 35.9827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5433",
    x1: 15.6364,
    y1: 1,
    x2: 16.2471,
    y2: 14.9912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0177F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5433",
    x1: 23,
    y1: 13,
    x2: 23,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterquality);
export default __webpack_public_path__ + "static/media/waterquality.a5f4802a9630fa574a5d270ebe481eb0.svg";
export { ForwardRef as ReactComponent };